import { useForm } from 'react-hook-form';
import TextField from '../Reusable/Form/TextInput';
import Button from '../Reusable/Button';
import usePatchHook from '../../customHooks/useUserServicePatchHook';
import APIS from '../../constant/EndPoint';

const UserLoginInfo = (props: any) => {
  const { user, profile } = props
  const {
    register,
    setError,
    handleSubmit,
    formState: { errors },
  } = useForm<any>({
    defaultValues: async () => {
      return {
        ...user
      }
    }
  });
  const { mutateAsync, isLoading: isPatchLoading } = usePatchHook({
    queryKey: ["users"],
    navigateURL: "",
  });

  const handleUpdateProfile = async (values: any, setError: any) => {
    const url = `${APIS.USER}${user?.id}/`;
    let formData = {
      ...values,
    };
    try {
      await mutateAsync({ url, formData, setError });
    } catch (err) {
      console.log(err);
    }
  }

  return (
    <>
    <form onSubmit={handleSubmit((data: any) => handleUpdateProfile(data, setError))} autoComplete="off">
      <div className="grid grid-cols-1 md:grid-cols-2 gap-x-4 mx-4">
        <TextField
          label={"Email"}
          register={register("email", { disabled: !profile?.is_superuser })}
          errors={errors?.email}
        />
        <TextField
          label={"Username"}
          register={register("username", { disabled: !profile?.is_superuser })}
          errors={errors?.username}
        />
        <TextField
          label={"Mobile Number"}
          register={register("mobile_number", { disabled: !profile?.is_superuser })}
          errors={errors?.mobile_number}
        />
      </div>
      <div className="flex justify-end w-full">
        <div className="w-[100px] mr-4">
          <Button label={"Update"} disabled={!profile?.is_superuser} isLoading={isPatchLoading}/>
        </div>
      </div>
      </form>
    </>
  )
}

export default UserLoginInfo